<template>
  <div class="test_menu clearfix">
    <a href="javascript:;" class="item">
      <em class="num">01</em>
      <h6 class="tit">学习态度问卷</h6>
      <p class="font">learning attitude</p>
    </a>
  </div>
</template>

<script>
  export default{
    data(){
      return {
      }
    },
    created (){
    },
    mounted(){
        this.fullscreen()
    },
  }
</script>


